import { render, staticRenderFns } from "./TicketFeedbackList.vue?vue&type=template&id=2371363d&scoped=true&lang=pug"
import script from "./TicketFeedbackList.vue?vue&type=script&lang=js"
export * from "./TicketFeedbackList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2371363d",
  null
  
)

export default component.exports